import styled from "styled-components";

const COLORS = {
    cardBg: "#0A1A3C",
    cardHover: "#122855",
    arrowBg: "#DDDDDD",
    arrowHover: "#EEE",
    arrowColor: "#9F9999",
};

export const Container = styled.div`
    width: 100%;
    max-width: 1070px;
    margin: 2rem auto;
    border-radius: 20px;
    padding: 1rem 0;
    position: relative;
`;

export const CarouselArea = styled.div`
    overflow: hidden;
    padding: 0 16px;
    width: ${({ width }) => `${width}px`};
    margin: 0 auto;
`;

// Mobile: cabem 2 cards inteiros + metade do terceiro (16px de padding + 2 gaps de 12px),
// para indicar que dá para arrastar. Limitado a 180px em telas maiores
export const MOBILE_CARD_WIDTH = "min(calc((100vw - 40px) / 2.5), 180px)";

// Mobile: rolagem horizontal nativa (arrastar com o dedo), parando no início de um card
export const SwipeArea = styled.div`
    width: 100%;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-padding: 0 16px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding: 0 16px;
    box-sizing: border-box;

    &::-webkit-scrollbar {
        display: none;
    }

    & > div {
        width: max-content;
        margin: 0 auto;
    }

    & a {
        width: ${MOBILE_CARD_WIDTH};
        scroll-snap-align: start;
    }
`;

export const CarouselContent = styled.div`
    display: flex;
    gap: ${({ gap }) => `${gap}px`};
    transform: ${({ translate }) => `translateX(-${translate}px)`};
    transition: transform 0.3s ease-in-out;
`;

export const CategoryCard = styled.a`
    flex: 0 0 auto;
    width: ${({ width }) => `${width}px`};
    height: 140px;
    background-color: ${COLORS.cardBg};
    color: #fff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 8px;
    cursor: pointer;
    text-decoration: none;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${COLORS.cardHover};
    }
`;

export const CategoryName = styled.span`
    font-weight: 600;
    font-size: ${({ isMobile, isSmall }) =>
        isSmall ? (isMobile ? "10px" : "12px") : isMobile ? "14px" : "16px"};
    line-height: 1.2;
    max-width: 90%;
    text-align: center;
    overflow-wrap: break-word;
    hyphens: auto;
    word-break: break-word;
`;

export const ArrowButton = styled.button`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    background-color: ${COLORS.arrowBg};
    color: ${COLORS.arrowColor};
    border: none;
    border-radius: 50%;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.1);

    &:hover {
        background-color: ${COLORS.arrowHover};
    }
`;

export const ArrowButtonLeft = styled(ArrowButton)`
    left: 0;
`;

export const ArrowButtonRight = styled(ArrowButton)`
    right: 0;
`;
